import * as React from "react";
import { withRouter, RouteComponentProps } from "react-router";
import { connect } from "react-redux";
import { createGlobalStyle } from "styled-components";
import { Reset } from "@conserveit/blocks";
import { Page, Container } from "../../components/Layout/Page";
import AppChrome from "../../components/AppChrome";
import * as authActions from "../../redux/modules/auth/actionCreators";
import { routeChangeEvent } from "../../utils/eventTracking";

interface ConnectedProps {
  appReady: boolean;
  user: Insite.AppState["auth"]["user"];
}

type Props = ConnectedProps &
  RouteComponentProps & { children?: React.ReactNode };

function mapStateToProps(state: Insite.AppState) {
  return {
    appReady: state.appSetup.appSetupComplete,
    user: state.auth.user,
  };
}

const GlobalStyle = createGlobalStyle``;

const AppCon: React.FC<Props> = ({ user, appReady, children, location }) => {
  React.useEffect(() => {
    if (appReady && user && user.token) {
      routeChangeEvent({
        search: location.search,
        pathname: location.pathname,
      });
    }
  }, [location.pathname, appReady]);

  return (
    <React.Fragment>
      <Reset />
      <GlobalStyle />
      <Page>
        <AppChrome user={user} appReady={appReady} />
        <Container>{children}</Container>
      </Page>
    </React.Fragment>
  );
};

export const AppContainer = withRouter(
  connect(mapStateToProps, { ...authActions })(AppCon)
);
